import React, { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { exchangeGoogle } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = location.hash || window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    (async () => {
      if (sessionId) {
        try {
          await exchangeGoogle(sessionId);
        } catch (e) {
          navigate("/login", { replace: true });
          return;
        }
      }
      window.history.replaceState(null, "", window.location.pathname);
      navigate("/dashboard", { replace: true });
    })();
  }, [location.hash, exchangeGoogle, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F8FAFC]" data-testid="auth-callback">
      <div className="text-center">
        <div className="w-10 h-10 border-2 border-slate-900 border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-slate-600">Signing you in…</p>
      </div>
    </div>
  );
}
